import React from 'react';
import { IconSvgProps } from '@models/common';

const AcademicCap: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'>
      <path
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        d='M5.00001 11V16.6812C5.00001 17.4813 5.4768 18.2044 6.21217 18.5195L11.2122 20.6624C11.7153 20.878 12.2847 20.878 12.7878 20.6624L17.7878 18.5195C18.5232 18.2044 19 17.4813 19 16.6812V11M22 9.00002V14M1.89444 8.0528L11.1056 3.44723C11.6686 3.1657 12.3314 3.1657 12.8944 3.44723L22.1056 8.0528C22.4741 8.23706 22.4741 8.76297 22.1056 8.94723L12.8944 13.5528C12.3314 13.8343 11.6686 13.8343 11.1056 13.5528L1.89444 8.94723C1.52591 8.76297 1.52591 8.23706 1.89444 8.0528Z'
      />
    </svg>
  );
};

export default AcademicCap;
